import { render, staticRenderFns } from "./RequestsSeller.vue?vue&type=template&id=939295b2&scoped=true&"
import script from "./RequestsSeller.vue?vue&type=script&lang=js&"
export * from "./RequestsSeller.vue?vue&type=script&lang=js&"
import style0 from "./RequestsSeller.vue?vue&type=style&index=0&id=939295b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939295b2",
  null
  
)

export default component.exports